// extracted by mini-css-extract-plugin
module.exports = {"popover_container":"hoverablePopoverTrigger_popover_container__RiMbh"};